module.exports = __webpack_public_path__ + "img/qrcode.61d6ac34.png";